import type { UserProfile } from '@/types/user';

/**
 * 权限类型（与后端一致）
 */
export const PERMISSION_TYPE = {
  MENU: 'menu',
  BUTTON: 'button'
} as const;

export const PERMISSION_TYPE_LABELS = {
  menu: '菜单',
  button: '按钮'
} as const;

/**
 * 判断当前用户是否为超级管理员（系统级只有 username === 'admin' 或拥有 superAdmin 角色才是超级管理员）
 * 注意：租户编码 tenantCode === 'admin' 仅代表该用户属于 admin 租户，绝不代表用户是超级管理员！
 * @param user - 当前用户
 * @returns boolean
 */
export function isSuperAdmin(user?: UserProfile | null): boolean {
  return Boolean(user && (user.username === 'admin' || user.roleCode === 'superAdmin'));
}

/**
 * 判断当前用户是否为租户管理员（根据用户角色 roleCode === 'tenantAdmin' 判断）
 * @param user - 当前用户
 * @param tenantCode - 可选，特定租户编码；若传入则同时判断是否为该租户的管理员
 * @returns boolean
 */
export function isTenantAdmin(user?: UserProfile | null, tenantCode?: string): boolean {
  if (!user) return false;
  const hasTenantAdminRole = user.roleCode === 'tenantAdmin';
  if (!hasTenantAdminRole) return false;
  if (tenantCode) {
    return user.tenantCode === tenantCode;
  }
  return true;
}

/**
 * 判断用户是否拥有指定权限码
 * @param user - 当前用户（含 permissions 数组）
 * @param code - 权限码
 * @returns boolean
 */
export function hasPermission(user?: UserProfile | null, code?: string): boolean {
  if (!code) return true;
  if (isSuperAdmin(user) && (!user?.permissions || user.permissions.length === 0)) return true;
  if (!user || !user.permissions || !Array.isArray(user.permissions)) return false;
  if (code === 'menu.omni' && (user.permissions as any[]).includes('menu.pdd')) return true;
  return (user.permissions as any[]).includes(code);
}
